/* unplugin-vue-components disabled */import { render } from "./qrcode2.vue?vue&type=template&id=210cfa72"
import script from "./qrcode2.vue?vue&type=script&lang=js"
export * from "./qrcode2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__